import React, { CSSProperties } from 'react';
import { Flex, useColorMode, Box } from '@tonic-ui/react';
import { useTranslation } from 'react-i18next';
import styles from './loader.module.css';

type OverlayLoaderProps = {
  isLoading: boolean;
} & CSSProperties;

const Loader = () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  return (
    <Flex width="100%" height="100%" alignItems="center">
      <div className={styles.loader_page}>
        <div className={styles.loader_icon}>
          <div className={styles.ball_pulse}>
            <div />
            <div />
            <div />
          </div>
        </div>
        <h2 className={`${styles.loader_title} ${colorMode === 'dark' ? styles.dark : ''}`}>
          {t('loaderMessage')}
        </h2>
      </div>
    </Flex>
  );
};

const OverlayLoader = ({ isLoading, ...rest }: OverlayLoaderProps) => {
  if (!isLoading) return null;
  return (
    <Box position="absolute" top="0" left="0" bottom="0" right="0" zIndex="999" {...rest}>
      <Loader />
    </Box>
  );
};

OverlayLoader.displayName = 'OverlayLoader';
export default OverlayLoader;
